export const NAME = 'books';
export const LEVEL_ONE = 'BooksComponentReducer';

export const CHAPTER_AUDIO_PLAYLIST_LOADING = 'LOADING';
export const CHAPTER_AUDIO_PLAYLIST_SUCCESS = 'SUCCESS';
export const CHAPTER_AUDIO_PLAYLIST_ERROR = 'ERROR';

export const CHAPTER_AUDIO_PLAYLIST_GENERATION_LOADING = 'LOADING';
export const CHAPTER_AUDIO_PLAYLIST_GENERATION_SUCCESS = 'SUCCESS';
export const CHAPTER_AUDIO_PLAYLIST_GENERATION_ERROR = 'ERROR';
export const CHAPTER_AUDIO_PLAYLIST_GENERATION_PENDING = 'PENDING';
